import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import waves from '../assets/waves.png';
import welcome from '../assets/larence.jpg';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.png';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import wordpress from '../assets/wordpress.png';
import react from '../assets/react.png';
import javascript from '../assets/javascript.png';
import php from '../assets/php.png';
import woocommerce from '../assets/woocommerce.png';
import acf from '../assets/acf.png';
import elementor from '../assets/elementor.png';
import cpanel from '../assets/cpanel.png';
import jquery from '../assets/jquery.png';
import zapier from '../assets/zapier.png';
import bootstrap from '../assets/bootstrap.png';
import ionic from '../assets/ionic.png';
import ais_national_preview from '../assets/ais_national_preview.jpg';
import ais_national from '../assets/ais_national.png';
import ais_elevate_preview from '../assets/ais_elevate_preview.jpg';
import ais_elevate from '../assets/ais_elevate.png';
import wms_prot1 from '../assets/WMS_app_prot1.png';
import wms_prot2 from '../assets/WMS_app_prot2.png';
import mail from '../assets/mail.png';
import phone from '../assets/phone.png';
import skype from '../assets/skype.png';
import resume_docx from '../assets/resume.docx';
import resume_pdf from '../assets/resume.pdf';


export default {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  waves,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
  react,
  wordpress,
  javascript,
  php,
  woocommerce,
  acf,
  elementor,
  cpanel,
  jquery,
  zapier,
  bootstrap,
  ionic,
  ais_national_preview,
  ais_national,
  ais_elevate_preview,
  ais_elevate,
  wms_prot1,
  wms_prot2,
  mail,
  phone,
  skype,
  resume_docx,
  resume_pdf
};
